import React, { useState, useEffect, useCallback } from 'react'
import { Container, Row, Col, Card, Tab, Form, Button, Nav, OverlayTrigger, Tooltip, Modal, Badge } from 'react-bootstrap'
import Moment from 'moment';
import { Link, useNavigate, Route } from 'react-router-dom'
import { ToastProvider, useToasts } from 'react-toast-notifications';
import { apiHandler } from '../../../api/apihandler';
import { CHANGE_PASSWORD, PROFILE_DETAILS, PROFILE_PIC_UPDATE, PROFILE_UPDATE } from "../../../api/constants";
import { handleImageUpload } from "../../../api/uploads";
import { Icon } from 'react-icons-kit';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { eye } from 'react-icons-kit/feather/eye'
import Swal from 'sweetalert2'
import Cropper from 'react-easy-crop'

import getCroppedImg from '../../../utilities/crop-image'

// Redux Selector / Action
import { useDispatch } from 'react-redux';

// import state selectors
import { setUserData } from '../../../store/setting/actions'
import { useSelector } from 'react-redux';
import LoaderModal from '../../../components/loaderModal';
import AddressAutocomplete from '../../../components/addressAutocomplete';
import { isParentLoginProfile, getParentChildren, getSelectedChildProfile, getStoredParentStudentId, setStoredParentStudentId } from '../../../utilities/teacherModulePermissions';


const UserProfileEdit = () => {

    const navigate = useNavigate();
    const { addToast } = useToasts();
    const dispatch = useDispatch()
    const storedUserData = useSelector((state) => state.setting.setting.user_data);
    const user_data = storedUserData ? JSON.parse(storedUserData) : "";

    // A parent account edits its child's profile here, never its own — the
    // form is populated from whichever child is currently selected (the same
    // selection user-profile.js's "Viewing Child" dropdown drives), and every
    // apiHandler call below is auto-scoped to that child via the stored
    // student_id (see apihandler.js -> withParentStudentId).
    const isParentEditingChild = isParentLoginProfile(user_data);
    const parentChildren = getParentChildren(user_data);
    const editTargetProfile = isParentEditingChild ? (getSelectedChildProfile(user_data) || {}) : user_data;

    // Check if Parent Info tab should be shown — evaluated against whoever is
    // actually being edited (the child, for a parent) rather than the logged-in
    // account, since that's whose eligibility (user_type, influencer/dance
    // corner flags) actually determines it.
    const showParentInfoTab = editTargetProfile?.user_type != 4 &&
                               editTargetProfile?.user_type != 2 &&
                               editTargetProfile?.user_setting?.is_influencer === 0 &&
                               editTargetProfile?.user_setting?.is_dance_corner === 0 &&
                               (process.env.REACT_APP_IS_CLASS_AVAILABLE == 1 || process.env.REACT_APP_IS_CLASS_AVAILABLE === "1");

    console.log("Parent Info Tab Debug:", {
        user_type: editTargetProfile?.user_type,
        is_influencer: editTargetProfile?.user_setting?.is_influencer,
        is_dance_corner: editTargetProfile?.user_setting?.is_dance_corner,
        class_available: process.env.REACT_APP_IS_CLASS_AVAILABLE,
        showParentInfoTab
    });

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [mobile, setMobile] = useState('')
    const [gender, setGender] = useState('1')
    const [email, setEmail] = useState('')
    const [bio, setBio] = useState('')
    const [address, setAddress] = useState('')
    const [dob, setDOB] = useState('')
    const [website, setWebSite] = useState('')
    const [profileImage, setProfileImage] = useState('')

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [opType, setOPType] = useState('password');
    const [opIcon, setOPIcon] = useState(eyeOff);
    const [npType, setNPType] = useState('password');
    const [npIcon, setNPIcon] = useState(eyeOff);
    const [cpType, setCPType] = useState('password');
    const [cpIcon, setCPIcon] = useState(eyeOff);

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCroper, setShowCroper] = useState(false)
    const [imageForCrop, setImageForCrop] = useState("")
    const [rotation, setRotation] = useState(0)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [activeEditTab, setActiveEditTab] = useState('first')

    const [showLoader, setShowLoader] = useState(false);

    // Parent Info states
    const [fathersName, setFathersName] = useState('');
    const [fathersPhone, setFathersPhone] = useState('');
    const [fathersEmail, setFathersEmail] = useState('');
    const [fathersOccupation, setFathersOccupation] = useState('');
    const [mothersName, setMothersName] = useState('');
    const [mothersPhone, setMothersPhone] = useState('');
    const [mothersEmail, setMothersEmail] = useState('');
    const [mothersOccupation, setMothersOccupation] = useState('');
    const [guardianName, setGuardianName] = useState('');
    const [guardianRelationship, setGuardianRelationship] = useState('');
    const [guardianPhone, setGuardianPhone] = useState('');
    const [guardianEmail, setGuardianEmail] = useState('');
    const [guardianAddress, setGuardianAddress] = useState('');
    const [allergies, setAllergies] = useState('');
    const [medicalConditions, setMedicalConditions] = useState('');
    const [doctorsName, setDoctorsName] = useState('');
    const [doctorsPhone, setDoctorsPhone] = useState('');
    const [immunizationRecord, setImmunizationRecord] = useState('');
    const [healthInsuranceProvider, setHealthInsuranceProvider] = useState('');
    const [emergencyContactName, setEmergencyContactName] = useState('');
    const [emergencyRelationship, setEmergencyRelationship] = useState('');
    const [emergencyContactNumber, setEmergencyContactNumber] = useState('');
    const [emergencyAlternateNumber, setEmergencyAlternateNumber] = useState('');
    const [emergencyAddress, setEmergencyAddress] = useState('');
    const [specialNeedsOrRemarks, setSpecialNeedsOrRemarks] = useState('');
    const [notes, setNotes] = useState('');

    const handleAddressSelect = ({ address, latLng, details }) => {
        // console.log("Selected Address:", address);
        setAddress(address)
        // console.log("Coordinates:", latLng);
        // console.log("Full Details:", details);
        // You can use details.address_components to autofill form fields
    };

    const handleShowCroper = () => {
        setShowCroper(true)
    }
    const handleCloseCroper = () => {
        setShowCroper(false)
    }

    const resizeComplete = async () => {
        await onCropComplete()
        await showCroppedImage()
    }
    const onCropComplete = async (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }

    const showCroppedImage = async () => {
        try {
            const croppedImage = await getCroppedImg(
                imageForCrop,
                croppedAreaPixels,
                rotation
            )
            //console.log(croppedImage)
            handleUpload(croppedImage)
            setProfileImage(URL.createObjectURL(croppedImage))
            handleCloseCroper()
        } catch (e) {
            console.error(e)
        }
    }

    const handleUpload = async (file) => {
        setShowLoader(true)
        try {
            const fileCon = new File([file], `${editTargetProfile?.slug || user_data?.slug}${Date.now()}.jpg`, { type: 'image/jpeg' });
            const url = await handleImageUpload(fileCon, "profilePhoto/", "image/jpeg")
            updateProfilePicApi(url)
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };

    const handleOPToggle = () => {
        if (opType === 'password') {
            setOPIcon(eye);
            setOPType('text')
        } else {
            setOPIcon(eyeOff)
            setOPType('password')
        }
    }

    const handleNPToggle = () => {
        if (npType === 'password') {
            setNPIcon(eye);
            setNPType('text')
        } else {
            setNPIcon(eyeOff)
            setNPType('password')
        }
    }

    const handleCPToggle = () => {
        if (cpType === 'password') {
            setCPIcon(eye);
            setCPType('text')
        } else {
            setCPIcon(eyeOff)
            setCPType('password')
        }
    }


    const handleImageChange = (event) => {
        const file = event.target.files[0];
        event.target.value = "";
        if (file) {
            const reader = new FileReader();
            reader.onloadend = async () => {
                handleShowCroper()
                setImageForCrop(reader.result)
            };
            reader.readAsDataURL(file);
        }
    };

    // Copy Father's information to Guardian fields
    const copyFatherInfoToGuardian = () => {
        if (!fathersName && !fathersPhone && !fathersEmail) {
            Swal.fire({
                title: 'No Data',
                text: 'Please fill father\'s information first',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }
        
        setGuardianName(fathersName || '');
        setGuardianPhone(fathersPhone || '');
        setGuardianEmail(fathersEmail || '');
        setGuardianRelationship('Father');
        setGuardianAddress(address || '');
        
        Swal.fire({
            title: 'Success',
            text: 'Father\'s information copied to guardian fields',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
        });
    };

    // Copy Mother's information to Guardian fields
    const copyMotherInfoToGuardian = () => {
        if (!mothersName && !mothersPhone && !mothersEmail) {
            Swal.fire({
                title: 'No Data',
                text: 'Please fill mother\'s information first',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }
        
        setGuardianName(mothersName || '');
        setGuardianPhone(mothersPhone || '');
        setGuardianEmail(mothersEmail || '');
        setGuardianRelationship('Mother');
        setGuardianAddress(address || '');
        
        Swal.fire({
            title: 'Success',
            text: 'Mother\'s information copied to guardian fields',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false
        });
    };

    // Populates every field on this page from a single profile object — the
    // logged-in user's own record normally, or (for a parent) the currently
    // selected child's record. Shared by the initial load, by the "Editing"
    // child-switcher, and by getProfileDetails() after a save, so there's one
    // place that defines what "the form" is filled from.
    const loadFieldsFromProfile = (profile) => {
        setFirstName(profile?.first_name || '')
        setLastName(profile?.last_name || '')
        setEmail(profile?.email || '')
        setMobile(profile?.user_setting?.mobile_no || '')
        setWebSite(profile?.user_setting?.website || '')
        setDOB(profile?.user_setting?.dob ? Moment(profile.user_setting.dob).format('YYYY-MM-DD') : '')
        setGender(profile?.user_setting?.gender)
        setProfileImage(profile?.user_setting?.photo)
        setBio(profile?.user_setting?.bio || '')
        setAddress(profile?.user_setting?.address || '')

        // Parent/family info
        setFathersName(profile?.user_setting?.fathers_name || '')
        setFathersPhone(profile?.user_setting?.fathers_phone || '')
        setFathersEmail(profile?.user_setting?.fathers_email || '')
        setFathersOccupation(profile?.user_setting?.fathers_occupation || '')
        setMothersName(profile?.user_setting?.mothers_name || '')
        setMothersPhone(profile?.user_setting?.mothers_phone || '')
        setMothersEmail(profile?.user_setting?.mothers_email || '')
        setMothersOccupation(profile?.user_setting?.mothers_occupation || '')
        setGuardianName(profile?.user_setting?.guardian_name || '')
        setGuardianRelationship(profile?.user_setting?.guardian_relationship || '')
        setGuardianPhone(profile?.user_setting?.guardian_phone || '')
        setGuardianEmail(profile?.user_setting?.guardian_email || '')
        setGuardianAddress(profile?.user_setting?.guardian_address || '')
        setAllergies(profile?.user_setting?.allergies || '')
        setMedicalConditions(profile?.user_setting?.medical_conditions || '')
        setDoctorsName(profile?.user_setting?.doctors_name || '')
        setDoctorsPhone(profile?.user_setting?.doctors_phone || '')
        setImmunizationRecord(profile?.user_setting?.immunization_record || '')
        setHealthInsuranceProvider(profile?.user_setting?.health_insurance_provider || '')
        setEmergencyContactName(profile?.user_setting?.emergency_contact_name || '')
        setEmergencyRelationship(profile?.user_setting?.emergency_relationship || '')
        setEmergencyContactNumber(profile?.user_setting?.emergency_contact_number || '')
        setEmergencyAlternateNumber(profile?.user_setting?.emergency_alternate_number || '')
        setEmergencyAddress(profile?.user_setting?.emergency_address || '')
        setSpecialNeedsOrRemarks(profile?.user_setting?.special_needs_or_remarks || '')
        setNotes(profile?.user_setting?.notes || '')
    };

    // Switches which linked child a parent is editing — mirrors
    // user-profile.js's handleSelectChild so the two pages stay in sync via
    // the same stored student_id.
    const handleSelectChild = (newChildId) => {
        if (!newChildId || String(newChildId) === String(getStoredParentStudentId() || editTargetProfile?.id)) {
            return;
        }

        setStoredParentStudentId(newChildId);
        dispatch(setUserData(JSON.stringify({ ...user_data, selected_student_id: newChildId })));

        const newChild = parentChildren.find((child) => String(child?.id) === String(newChildId));
        if (newChild) {
            loadFieldsFromProfile(newChild);
        }
    };

    const [isFirst, setIsFirst] = useState(true);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsFirst(false)
    }, [isFirst]);

    // Depends on storedUserData (the raw Redux string), not editTargetProfile
    // (a new object literal every render) - on a hard reload, redux-persist
    // hasn't rehydrated yet when this first mounts, so storedUserData is
    // still "" and editTargetProfile is empty; with an empty dependency
    // array this effect only ever ran once, right then, permanently
    // populating every field from that empty object. A plain in-app
    // navigation to this page never hit that gap since the store was
    // already warm, which is why the bug only showed up on reload. Now it
    // re-runs once storedUserData actually lands with the real data.
    useEffect(() => {
        if (localStorage.getItem("uzoneAuthToken")) {
            loadFieldsFromProfile(editTargetProfile);
        } else {
            navigate('/')
        }
    }, [storedUserData]);

    function handleOnChange(e) {
        console.log('selected option', e);
        if (e === "option1") {
            setGender(0)
        } else if (e === "option2") {
            setGender(1)
        } else if (e === "option3") {
            setGender(2)
        }
    }

    function handleUpdateSubmit() {
        if (firstName === "") {
            Swal.fire({
                title: 'Error!',
                text: 'Enter first name!',
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        } else if (lastName === "") {
            Swal.fire({
                title: 'Error!',
                text: 'Enter last name!',
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        } else if (dob === "") {
            Swal.fire({
                title: 'Error!',
                text: 'Enter date of birth!',
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        } else if (gender === "") {
            Swal.fire({
                title: 'Error!',
                text: 'Please select gender',
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        } else {
            updateProfile()
        }
    };

    async function getProfileDetails() {
        try {
            const res = await apiHandler(PROFILE_DETAILS, "POST")
            if (res.data?.response?.status === 200) {
                // For a parent account this always returns the PARENT's own
                // record plus a sibling `children` array (one entry per linked
                // student) — never a record scoped to the selected child — so
                // Redux must keep storing the parent's own object, with the
                // child's info coming out of `children` via editTargetProfile,
                // exactly like user-profile.js does.
                const rawUser = res?.data?.data?.user;
                const children = res?.data?.data?.children;
                const mergedUser = {
                    ...rawUser,
                    ...(Array.isArray(children) ? { children } : (Array.isArray(user_data?.children) ? { children: user_data.children } : {})),
                    ...(user_data?.selected_student_id ? { selected_student_id: user_data.selected_student_id } : {}),
                };
                dispatch(setUserData(JSON.stringify(mergedUser)));

                const refreshedTarget = isParentLoginProfile(mergedUser) ? (getSelectedChildProfile(mergedUser) || {}) : mergedUser;
                loadFieldsFromProfile(refreshedTarget);
            } else {
                navigate('/')
                //addToast(res?.response?.data?.data?.message, { appearance: 'error' });
                //console.log("profileRes",res)
            }
        } catch (error) {
            console.error(error);
        }
        finally {
        }
    }

    async function updateProfile() {
        try {
            const res = await apiHandler(PROFILE_UPDATE, "POST", {
                first_name: firstName,
                last_name: lastName,
                gender: gender,
                dob: dob,
                mobile_no: mobile,
                interest_id: "1",
                bio: bio,
                website: website,
                address: address
            })
            if (res.data?.response?.status === 200) {
                if (isParentEditingChild) {
                    // res.data.data.user here is the CHILD's updated record (the
                    // request was scoped to it via student_id), not the parent's
                    // own account — dispatching it straight into user_data would
                    // silently replace the parent's own profile with the child's.
                    // Refetch the canonical parent+children shape instead.
                    await getProfileDetails();
                } else {
                    dispatch(setUserData(JSON.stringify({
                        ...res?.data?.data?.user,
                        ...(Array.isArray(user_data?.children) ? { children: user_data.children } : {}),
                        ...(user_data?.selected_student_id ? { selected_student_id: user_data.selected_student_id } : {}),
                    })));
                }
                Swal.fire({
                    title: 'Success!',
                    text: isParentEditingChild ? "Your child's profile updated successfully." : 'Your profile updated successfully.',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })
            } else {
                addToast(res?.response?.data?.data?.message, { appearance: 'error' });
                // router.push('/login')
                // console.log("updateProfileRes",res)
            }
        } catch (error) {
            console.error(error);
        }
        finally {
        }
    }

    async function updateParentInfo() {
        setShowLoader(true);
        try {
            const res = await apiHandler(PROFILE_UPDATE, "POST", {
                first_name: firstName,
                last_name: lastName,
                fathers_name: fathersName,
                fathers_phone: fathersPhone,
                fathers_email: fathersEmail,
                fathers_occupation: fathersOccupation,
                mothers_name: mothersName,
                mothers_phone: mothersPhone,
                mothers_email: mothersEmail,
                mothers_occupation: mothersOccupation,
                guardian_name: guardianName,
                guardian_relationship: guardianRelationship,
                guardian_phone: guardianPhone,
                guardian_email: guardianEmail,
                guardian_address: guardianAddress,
                allergies: allergies,
                medical_conditions: medicalConditions,
                doctors_name: doctorsName,
                doctors_phone: doctorsPhone,
                immunization_record: immunizationRecord,
                health_insurance_provider: healthInsuranceProvider,
                emergency_contact_name: emergencyContactName,
                emergency_relationship: emergencyRelationship,
                emergency_contact_number: emergencyContactNumber,
                emergency_alternate_number: emergencyAlternateNumber,
                emergency_address: emergencyAddress,
                special_needs_or_remarks: specialNeedsOrRemarks,
                notes: notes
            })
            if (res.data?.response?.status === 200) {
                // Fetch complete profile details which will update Redux properly
                await getProfileDetails();
                Swal.fire({
                    title: 'Success!',
                    text: 'Parent information updated successfully.',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: res?.response?.data?.data?.message || 'Failed to update parent information',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                title: 'Error!',
                text: 'An error occurred while updating parent information',
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        finally {
            setShowLoader(false);
        }
    }

    async function updateProfilePicApi(url) {
        try {
            const res = await apiHandler(PROFILE_PIC_UPDATE, "POST", {
                photo: url
            })
            if (res.data?.response?.status == 200) {
                if (isParentEditingChild) {
                    // Same reasoning as updateProfile(): the returned record is
                    // the child's, so resync via a full refetch instead of
                    // overwriting the parent's own Redux profile with it.
                    await getProfileDetails();
                } else {
                    dispatch(setUserData(JSON.stringify({
                        ...res?.data?.data?.user,
                        ...(Array.isArray(user_data?.children) ? { children: user_data.children } : {}),
                        ...(user_data?.selected_student_id ? { selected_student_id: user_data.selected_student_id } : {}),
                    })));
                }
                Swal.fire({
                    title: 'Success!',
                    text: isParentEditingChild ? "Your child's profile photo updated successfully." : 'Your profile image uploaded successfully.',
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })
            } else if (res.data?.response?.status == 400) {
                Swal.fire({
                    title: 'Error',
                    text: res?.response?.data?.data?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                // router.push('/login')
                // console.log("updateProfileRes",res)
                Swal.fire({
                    title: 'Error',
                    text: res?.response?.data?.data?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowLoader(false)
        }
    }

    async function changePassword() {
        const res = await apiHandler(CHANGE_PASSWORD, "POST", {
            new_password: newPassword,
            confirm_password: confirmPassword,
            old_password: oldPassword
        })
        if (res.data?.response?.status === 200) {
            Swal.fire({
                title: 'Success!',
                text: 'Your password changed successfully.',
                icon: 'success',
                confirmButtonText: 'Okay'
            })
        } else {
            addToast(res?.response?.data?.data?.message, { appearance: 'error' });
        }
    }


    return (
        <>
            <LoaderModal showLoader={showLoader} />
            <Container style={{ marginTop: "10px" }}>
                <Tab.Container activeKey={activeEditTab} onSelect={(key) => setActiveEditTab(key || 'first')}>
                    <Row>
                        <Col sm={12}>
                            <Card style={{ marginLeft: "7px", marginRight: "7px", border: '1px solid #eceff3', borderRadius: '12px' }}>
                                <Card.Body className="p-0">
                                    {isParentEditingChild && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', padding: '14px 16px', borderBottom: '1px solid #eceff3', background: '#f9fafb' }}>
                                            <img
                                                src={editTargetProfile?.user_setting?.photo || "https://uzone360live.s3.amazonaws.com/noimage.png"}
                                                alt="child"
                                                style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                                            />
                                            <div style={{ flex: 1, minWidth: '160px' }}>
                                                <div style={{ fontSize: '11px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>Editing Child's Profile</div>
                                                <div style={{ fontSize: '15px', fontWeight: 700, color: '#1f2937' }}>
                                                    {editTargetProfile?.first_name} {editTargetProfile?.last_name}
                                                </div>
                                            </div>
                                            {parentChildren.length > 1 && (
                                                <Form.Group style={{ minWidth: '200px' }}>
                                                    <Form.Select
                                                        size='sm'
                                                        value={String(getStoredParentStudentId() || editTargetProfile?.id || '')}
                                                        onChange={(e) => handleSelectChild(e.target.value)}
                                                    >
                                                        {parentChildren.map((child) => (
                                                            <option key={child?.id} value={child?.id}>
                                                                {child?.first_name} {child?.last_name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            )}
                                        </div>
                                    )}
                                    <div style={{ padding: '0 16px', borderBottom: '1px solid #eceff3', overflowX: 'auto' }}>
                                        <Nav as='div' style={{ display: 'flex', minWidth: 'max-content' }}>
                                            <Nav.Link
                                                eventKey='first'
                                                role='button'
                                                style={{
                                                    position: 'relative',
                                                    border: 'none',
                                                    borderRadius: 0,
                                                    background: 'transparent',
                                                    borderBottom: activeEditTab === 'first' ? '2px solid var(--bs-warning)' : '2px solid transparent',
                                                    color: activeEditTab === 'first' ? 'var(--bs-warning)' : '#6b7280',
                                                    fontSize: '13px',
                                                    fontWeight: 600,
                                                    padding: '10px 12px'
                                                }}
                                            >
                                                {isParentEditingChild ? "Child's Information" : "Personal Information"}
                                            </Nav.Link>
                                            {!isParentEditingChild && (
                                                <Nav.Link
                                                    eventKey='second'
                                                    role='button'
                                                    style={{
                                                        position: 'relative',
                                                        border: 'none',
                                                        borderRadius: 0,
                                                        background: 'transparent',
                                                        borderBottom: activeEditTab === 'second' ? '2px solid var(--bs-warning)' : '2px solid transparent',
                                                        color: activeEditTab === 'second' ? 'var(--bs-warning)' : '#6b7280',
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        padding: '10px 12px'
                                                    }}
                                                >
                                                    Change Password
                                                </Nav.Link>
                                            )}
                                            {showParentInfoTab && (
                                                <Nav.Link
                                                    eventKey='fifth'
                                                    role='button'
                                                    style={{
                                                        position: 'relative',
                                                        border: 'none',
                                                        borderRadius: 0,
                                                        background: 'transparent',
                                                        borderBottom: activeEditTab === 'fifth' ? '2px solid var(--bs-warning)' : '2px solid transparent',
                                                        color: activeEditTab === 'fifth' ? 'var(--bs-warning)' : '#6b7280',
                                                        fontSize: '13px',
                                                        fontWeight: 600,
                                                        padding: '10px 12px'
                                                    }}
                                                >
                                                    Parent Info
                                                </Nav.Link>
                                            )}
                                        </Nav>
                                    </div>
                            <Tab.Content>
                                <Tab.Pane eventKey="first" className="fade show">
                                        <Card.Body>
                                            {/* <Form onSubmit={handleSubmit}> */}
                                            <Form.Group className="form-group align-items-center">
                                                <Col md="12">
                                                    <div className="profile-img-edit">
                                                        {/* <img className="profile-pic" src={img1} alt="profile-pic" /> */}
                                                        <img className="profile-pic" style={{ height: 150, width: 150 }}
                                                            src={profileImage ? profileImage : "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="profile-pic" />
                                                        <div className="p-image">
                                                            <label htmlFor="imageUpload1">
                                                                <i className="ri-pencil-line upload-button text-white" alt="preview image" />
                                                            </label>
                                                            <input className="file-upload"
                                                                id="imageUpload1" type="file" accept="image/*"
                                                                //multiple="multiple"
                                                                onChange={
                                                                    handleImageChange
                                                                } />
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Form.Group>
                                            <Row className="align-items-center">
                                                <Form.Group className="form-group col-sm-6">
                                                    <Form.Label htmlFor="fname" className="form-label">First Name: *</Form.Label>
                                                    <Form.Control type="text" className="form-control" id="fname" placeholder="First Name"
                                                        value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                                </Form.Group>
                                                <Form.Group className="form-group col-sm-6">
                                                    <Form.Label htmlFor="lname" className="form-label">Last Name: *</Form.Label>
                                                    <Form.Control type="text" className="form-control" id="lname" placeholder="Last Name"
                                                        value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                                </Form.Group>
                                                <Form.Group className="form-group col-sm-6">
                                                    <Form.Label htmlFor="email" className="form-label">Email:</Form.Label>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <Form.Control type="email" className="form-control" id="email" value={email} disabled readOnly />
                                                        <Badge bg="success" className="p-2" style={{ whiteSpace: "nowrap" }}>
                                                            <i className="material-symbols-outlined" style={{ fontSize: '14px', verticalAlign: 'middle' }}>verified</i>
                                                            {' '}Verified
                                                        </Badge>
                                                    </div>
                                                </Form.Group>
                                                <Form.Group className="form-group col-sm-6">
                                                    <Form.Label htmlFor="website" className="form-label">Web site:</Form.Label>
                                                    <Form.Control type="text" className="form-control" id="website" placeholder="Web site"
                                                        value={website} onChange={(e) => setWebSite(e.target.value)} />
                                                </Form.Group>
                                                <Form.Group className="form-group col-sm-6">
                                                    <Form.Label htmlFor="dob" className="form-label">Date Of Birth: *</Form.Label>
                                                    <Form.Control type="date" className="mb-0" id="dob" placeholder="Date of Birth"
                                                        max={new Date().toISOString().split("T")[0]}
                                                        //defaultValue={setDOB(date_variable)}
                                                        value={dob} onChange={(e) => setDOB(e.target.value)} />
                                                </Form.Group>
                                                <Form.Group className="form-group col-sm-6">
                                                    <Form.Label className="form-label d-block">Gender: *</Form.Label>
                                                    <Form.Check className="form-check form-check-inline">
                                                        <Form.Check.Input className="form-check-input" checked={gender == 0} onChange={(e) => handleOnChange(e.target.value)} type="radio" name="inlineRadioOptions" id="inlineRadio10" defaultValue="option1" />
                                                        <Form.Check.Label className="form-check-label" htmlFor="inlineRadio10">Male</Form.Check.Label>
                                                    </Form.Check>
                                                    <Form.Check className="form-check form-check-inline">
                                                        <Form.Check.Input className="form-check-input" checked={gender == 1} onChange={(e) => handleOnChange(e.target.value)} type="radio" name="inlineRadioOptions" id="inlineRadio11" defaultValue="option2" />
                                                        <Form.Check.Label className="form-check-label" htmlFor="inlineRadio11">Female</Form.Check.Label>
                                                    </Form.Check>
                                                    <Form.Check className="form-check form-check-inline">
                                                        <Form.Check.Input className="form-check-input" checked={gender == 2} onChange={(e) => handleOnChange(e.target.value)} type="radio" name="inlineRadioOptions" id="inlineRadio12" defaultValue="option3" />
                                                        <Form.Check.Label className="form-check-label" htmlFor="inlineRadio11">Other</Form.Check.Label>
                                                    </Form.Check>
                                                </Form.Group>
                                                {/* <Form.Group className="form-group col-sm-6">
                                                        <Form.Label className="form-label">Marital Status:</Form.Label>
                                                        <Form.Select defaultValue="Single" className="form-select" aria-label="Default select example">
                                                            <option>Single</option>
                                                            <option>Married</option>
                                                            <option>Widowed</option>
                                                            <option>Divorced</option>
                                                            <option>Separated </option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                    <Form.Group className="form-group col-sm-6">
                                                        <Form.Label className="form-label">Age:</Form.Label>
                                                        <Form.Select className="form-select" aria-label="Default select example 2">
                                                            <option>46-62</option>
                                                            <option>63 </option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                    <Form.Group className="form-group col-sm-6">
                                                        <Form.Label className="form-label">Country:</Form.Label>
                                                        <Form.Select defaultValue="USA" className="form-select" aria-label="Default select example 3">
                                                            <option>Caneda</option>
                                                            <option>Noida</option>
                                                            <option>USA</option>
                                                            <option>India</option>
                                                            <option>Africa</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                    <Form.Group className="form-group col-sm-6">
                                                        <Form.Label className="form-label">State:</Form.Label>
                                                        <Form.Select defaultValue="Georgia" className="form-select" aria-label="Default select example 4">
                                                            <option>California</option>
                                                            <option>Florida</option>
                                                            <option>Georgia</option>
                                                            <option>Connecticut</option>
                                                            <option>Louisiana</option>
                                                        </Form.Select>
                                                    </Form.Group> */}

                                                <Form.Group className="form-group col-sm-12">
                                                    <Form.Label className="form-label">Address:</Form.Label>
                                                    <AddressAutocomplete onSelect={handleAddressSelect} defaultAddress={address} />
                                                </Form.Group>

                                                <Form.Group className="form-group col-sm-12">
                                                    <Form.Label className="form-label">Bio:</Form.Label>
                                                    <Form.Control as="textarea" className="form-control" rows={5} style={{ lineHeight: "22px" }} placeholder="Enter Your Bio"
                                                        value={bio} onChange={(e) => setBio(e.target.value)}>
                                                    </Form.Control>
                                                </Form.Group>
                                                {/* <Form.Group className="form-group col-sm-12">
                                                    <Form.Label className="form-label">Address:</Form.Label>
                                                    <Form.Control as="textarea" className="form-control" rows={5} style={{ lineHeight: "22px" }} placeholder="Your Address here"
                                                        value={address} onChange={(e) => setAddress(e.target.value)}>
                                                    </Form.Control>
                                                </Form.Group> */}

                                            </Row>
                                            <Button className="btn btn-primary me-2" onClick={() => {
                                                handleUpdateSubmit()
                                            }}>Submit</Button>
                                            {/* <Button type="reset" className="btn bg-soft-danger">Cancel</Button> */}
                                            {/* </Form> */}
                                        </Card.Body>
                                </Tab.Pane>
                                {!isParentEditingChild && (
                                <Tab.Pane eventKey="second" className="fade show">
                                        <Card.Body>
                                            {/* <Form> */}
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="cpass" className="form-label">Current Password:</Form.Label>
                                                <Link to="/auth/recoverpw" className="float-end">Forgot Password</Link>
                                                <div style={{ position: "relative", marginBottom: 20, display: "flex", justifyContent: "end" }}>
                                                    <Form.Control type={opType} className="form-control" id="cpass" defaultValue=""
                                                        value={oldPassword} onChange={(e) => { setOldPassword(e.target.value) }} />
                                                    <Icon style={{ position: "absolute", marginTop: 7, marginRight: 8 }} icon={opIcon} size={20} onClick={handleOPToggle} />
                                                </div>
                                            </Form.Group>
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="npass" className="form-label">New Password:</Form.Label>
                                                <div style={{ position: "relative", marginBottom: 20, display: "flex", justifyContent: "end" }}>
                                                    <Form.Control type={npType} className="form-control" id="npass" defaultValue=""
                                                        value={newPassword} onChange={(e) => { setNewPassword(e.target.value) }} />
                                                    <Icon style={{ position: "absolute", marginTop: 7, marginRight: 8 }} icon={npIcon} size={20} onClick={handleNPToggle} />
                                                </div>
                                            </Form.Group>
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="vpass" className="form-label">Verify Password:</Form.Label>
                                                <div style={{ position: "relative", marginBottom: 30, display: "flex", justifyContent: "end" }}>
                                                    <Form.Control type={cpType} className="form-control" id="vpass" defaultValue=""
                                                        value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value) }} />
                                                    <Icon style={{ position: "absolute", marginTop: 7, marginRight: 8 }} icon={cpIcon} size={20} onClick={handleCPToggle} />
                                                </div>
                                            </Form.Group>
                                            <Button className="btn btn-primary me-2 " onClick={() => changePassword()}>Submit</Button>
                                            {/* <Button type="reset" className="btn bg-soft-danger">Cancel</Button> */}
                                            {/* </Form> */}
                                        </Card.Body>
                                </Tab.Pane>
                                )}
                                <Tab.Pane eventKey="third" className="fade show">
                                    <Card>
                                        <Card.Header className="card-header d-flex justify-content-between">
                                            <div className="header-title">
                                                <h4 className="card-title">Email and SMS</h4>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <Form>
                                                <Form.Group className="form-group row align-items-center">
                                                    <Form.Label className="col-md-3" htmlFor="emailnotification">Email Notification:</Form.Label>
                                                    <Form.Check className="col-md-9 form-check form-switch">
                                                        <Form.Check.Input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked11" defaultChecked />
                                                        <Form.Check.Label className="form-check-label" htmlFor="flexSwitchCheckChecked11">Checked switch checkbox input</Form.Check.Label>
                                                    </Form.Check>
                                                </Form.Group>
                                                <Form.Group className="form-group row align-items-center">
                                                    <Form.Label className="col-md-3" htmlFor="smsnotification">SMS Notification:</Form.Label>
                                                    <Form.Check className="col-md-9 form-check form-switch">
                                                        <Form.Check.Input className="form-check-input" type="checkbox" id="flexSwitchCheckChecked12" defaultChecked />
                                                        <Form.Check.Label className="form-check-label" htmlFor="flexSwitchCheckChecked12">Checked switch checkbox input</Form.Check.Label>
                                                    </Form.Check>
                                                </Form.Group>
                                                <Form.Group className="form-group row align-items-center">
                                                    <Form.Label className="col-md-3" htmlFor="npass">When To Email</Form.Label>
                                                    <Col md="9">
                                                        <Form.Check className="form-check">
                                                            <Form.Check.Input className="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefault12" />
                                                            <Form.Check.Label className="form-check-label" htmlFor="flexCheckDefault12">
                                                                You have new notifications.
                                                            </Form.Check.Label>
                                                        </Form.Check>
                                                        <Form.Check className="form-check d-block">
                                                            <Form.Check.Input className="form-check-input" type="checkbox" defaultValue="" id="email02" />
                                                            <Form.Check.Label className="form-check-label" htmlFor="email02">You're sent a direct message</Form.Check.Label>
                                                        </Form.Check>
                                                        <Form.Check className="form-check d-block">
                                                            <Form.Check.Input type="checkbox" className="form-check-input" id="email03" defaultChecked />
                                                            <Form.Check.Label className="form-check-label" htmlFor="email03">Someone adds you as a connection</Form.Check.Label>
                                                        </Form.Check>
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group className="form-group row align-items-center">
                                                    <Form.Label className="col-md-3" htmlFor="npass">When To Escalate Emails</Form.Label>
                                                    <Col md="9">
                                                        <Form.Check className="form-check">
                                                            <Form.Check.Input className="form-check-input" type="checkbox" defaultValue="" id="email04" />
                                                            <Form.Check.Label className="form-check-label" htmlFor="email04">
                                                                Upon new order.
                                                            </Form.Check.Label>
                                                        </Form.Check>
                                                        <Form.Check className="form-check d-block">
                                                            <Form.Check.Input className="form-check-input" type="checkbox" defaultValue="" id="email05" />
                                                            <Form.Check.Label className="form-check-label" htmlFor="email05">New membership approval</Form.Check.Label>
                                                        </Form.Check>
                                                        <Form.Check className="form-check d-block">
                                                            <Form.Check.Input type="checkbox" className="form-check-input" id="email06" defaultChecked />
                                                            <Form.Check.Label className="form-check-label" htmlFor="email06">Member registration</Form.Check.Label>
                                                        </Form.Check>
                                                    </Col>
                                                </Form.Group>
                                                <Button type="submit" className="btn btn-primary me-2">Submit</Button>
                                                <Button type="reset" className="btn bg-soft-danger">Cancel</Button>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </Tab.Pane>
                                {showParentInfoTab && (
                                    <Tab.Pane eventKey="fifth" className="fade show">
                                                <Card.Body>
                                                    <Row className="align-items-center">
                                                        {/* Father's Information */}
                                                        <Col md="12">
                                                            <h5 className="mb-3" style={{ color: 'var(--bs-primary)' }}>Father's Information</h5>
                                                        </Col>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Father's Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter father's name"
                                                                value={fathersName}
                                                                onChange={(e) => setFathersName(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Father's Phone</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter father's phone"
                                                                value={fathersPhone}
                                                                onChange={(e) => setFathersPhone(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Father's Email</Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                placeholder="Enter father's email"
                                                                value={fathersEmail}
                                                                onChange={(e) => setFathersEmail(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Father's Occupation</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter father's occupation"
                                                                value={fathersOccupation}
                                                                onChange={(e) => setFathersOccupation(e.target.value)}
                                                            />
                                                        </Form.Group>

                                                        {/* Mother's Information */}
                                                        <Col md="12" className="mt-4">
                                                            <h5 className="mb-3" style={{ color: 'var(--bs-primary)' }}>Mother's Information</h5>
                                                        </Col>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Mother's Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter mother's name"
                                                                value={mothersName}
                                                                onChange={(e) => setMothersName(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Mother's Phone</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter mother's phone"
                                                                value={mothersPhone}
                                                                onChange={(e) => setMothersPhone(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Mother's Email</Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                placeholder="Enter mother's email"
                                                                value={mothersEmail}
                                                                onChange={(e) => setMothersEmail(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Mother's Occupation</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter mother's occupation"
                                                                value={mothersOccupation}
                                                                onChange={(e) => setMothersOccupation(e.target.value)}
                                                            />
                                                        </Form.Group>

                                                        {/* Guardian Information */}
                                                        <Col md="12" className="mt-4">
                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                <h5 className="mb-0" style={{ color: 'var(--bs-primary)' }}>Guardian Information</h5>
                                                                <div className="d-flex gap-2">
                                                                    <Button 
                                                                        variant="outline-primary" 
                                                                        size="sm"
                                                                        onClick={copyFatherInfoToGuardian}
                                                                        style={{
                                                                            borderRadius: '8px',
                                                                            fontSize: '12px',
                                                                            padding: '6px 12px',
                                                                            fontWeight: '600',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px'
                                                                        }}
                                                                    >
                                                                        <i className="ri-parent-line"></i>
                                                                        Same as Father
                                                                    </Button>
                                                                    <Button 
                                                                        variant="outline-danger" 
                                                                        size="sm"
                                                                        onClick={copyMotherInfoToGuardian}
                                                                        style={{
                                                                            borderRadius: '8px',
                                                                            fontSize: '12px',
                                                                            padding: '6px 12px',
                                                                            fontWeight: '600',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px'
                                                                        }}
                                                                    >
                                                                        <i className="ri-parent-line"></i>
                                                                        Same as Mother
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Guardian Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter guardian name"
                                                                value={guardianName}
                                                                onChange={(e) => setGuardianName(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Guardian Relationship</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter relationship"
                                                                value={guardianRelationship}
                                                                onChange={(e) => setGuardianRelationship(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Guardian Phone</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter guardian phone"
                                                                value={guardianPhone}
                                                                onChange={(e) => setGuardianPhone(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Guardian Email</Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                placeholder="Enter guardian email"
                                                                value={guardianEmail}
                                                                onChange={(e) => setGuardianEmail(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-12">
                                                            <Form.Label>Guardian Address</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={2}
                                                                placeholder="Enter guardian address"
                                                                value={guardianAddress}
                                                                onChange={(e) => setGuardianAddress(e.target.value)}
                                                            />
                                                        </Form.Group>

                                                        {/* Medical Information */}
                                                        {/* <Col md="12" className="mt-4">
                                                            <h5 className="mb-3" style={{ color: 'var(--bs-primary)' }}>Medical Information</h5>
                                                        </Col>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Allergies</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter allergies"
                                                                value={allergies}
                                                                onChange={(e) => setAllergies(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Medical Conditions</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter medical conditions"
                                                                value={medicalConditions}
                                                                onChange={(e) => setMedicalConditions(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Doctor's Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter doctor's name"
                                                                value={doctorsName}
                                                                onChange={(e) => setDoctorsName(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Doctor's Phone</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter doctor's phone"
                                                                value={doctorsPhone}
                                                                onChange={(e) => setDoctorsPhone(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Immunization Record</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter immunization record"
                                                                value={immunizationRecord}
                                                                onChange={(e) => setImmunizationRecord(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Health Insurance Provider</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter insurance provider"
                                                                value={healthInsuranceProvider}
                                                                onChange={(e) => setHealthInsuranceProvider(e.target.value)}
                                                            />
                                                        </Form.Group> */}

                                                        {/* Emergency Contact Information */}
                                                        {/* <Col md="12" className="mt-4">
                                                            <h5 className="mb-3" style={{ color: 'var(--bs-primary)' }}>Emergency Contact Information</h5>
                                                        </Col>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Emergency Contact Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter contact name"
                                                                value={emergencyContactName}
                                                                onChange={(e) => setEmergencyContactName(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Emergency Relationship</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter relationship"
                                                                value={emergencyRelationship}
                                                                onChange={(e) => setEmergencyRelationship(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Emergency Contact Number</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter contact number"
                                                                value={emergencyContactNumber}
                                                                onChange={(e) => setEmergencyContactNumber(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-6">
                                                            <Form.Label>Emergency Alternate Number</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter alternate number"
                                                                value={emergencyAlternateNumber}
                                                                onChange={(e) => setEmergencyAlternateNumber(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-12">
                                                            <Form.Label>Emergency Address</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={2}
                                                                placeholder="Enter emergency address"
                                                                value={emergencyAddress}
                                                                onChange={(e) => setEmergencyAddress(e.target.value)}
                                                            />
                                                        </Form.Group> */}

                                                        {/* Additional Information */}
                                                        <Col md="12" className="mt-4">
                                                            <h5 className="mb-3" style={{ color: 'var(--bs-primary)' }}>Additional Information</h5>
                                                        </Col>
                                                        <Form.Group className="form-group col-sm-12">
                                                            <Form.Label>Special Needs or Remarks</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={3}
                                                                placeholder="Enter special needs or remarks"
                                                                value={specialNeedsOrRemarks}
                                                                onChange={(e) => setSpecialNeedsOrRemarks(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group className="form-group col-sm-12">
                                                            <Form.Label>Notes</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={3}
                                                                placeholder="Enter additional notes"
                                                                value={notes}
                                                                onChange={(e) => setNotes(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </Row>
                                                    <Button className="btn btn-primary me-2" onClick={() => updateParentInfo()}>
                                                        Submit
                                                    </Button>
                                                </Card.Body>
                                        </Tab.Pane>
                                    )}
                                <Tab.Pane eventKey="fourth" className="fade show">
                                    <Card>
                                        <Card.Header className="d-flex justify-content-between">
                                            <div className="header-title">
                                                <h4 className="card-title">Manage Contact</h4>
                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <Form>
                                                <Form.Group className="form-group">
                                                    <Form.Label htmlFor="cno" className="form-label">Contact Number:</Form.Label>
                                                    <Form.Control type="text" className="form-control" id="cno" defaultValue="001 2536 123 458" />
                                                </Form.Group>
                                                <Form.Group className="form-group">
                                                    <Form.Label htmlFor="email" className="form-label">Email:</Form.Label>
                                                    <Form.Control type="text" className="form-control" id="email" defaultValue="Bnijone@demo.com" />
                                                </Form.Group>
                                                <Form.Group className="form-group">
                                                    <Form.Label htmlFor="url" className="form-label">Url:</Form.Label>
                                                    <Form.Control type="text" className="form-control" id="url" defaultValue="https://getbootstrap.com" />
                                                </Form.Group>
                                                <Button type="submit" className="btn btn-primary me-2">Submit</Button>
                                                <Button type="reset" className="btn bg-soft-danger">Cancel</Button>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </Tab.Pane>
                                <Modal show={showCroper} onHide={handleCloseCroper} size="lg" style={{ marginTop: 100 }}>
                                    <Modal.Header className="d-flex justify-content-between">
                                        <h5 className="modal-title" id="post-modalLabel">Resize Profile Image </h5>
                                        <button type="button" className="btn btn-secondary lh-1" onClick={handleCloseCroper} ><span className="material-symbols-outlined">close</span></button>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="d-flex align-items-center" style={{ height: "300px" }}>
                                            <Cropper
                                                image={imageForCrop}
                                                crop={crop}
                                                zoom={zoom}
                                                aspect={4 / 4}
                                                cropShape={"rect"}
                                                onCropChange={setCrop}
                                                onCropComplete={onCropComplete}
                                                onZoomChange={setZoom}
                                            />
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="primary" className="d-block w-100 mt-3"
                                            onClick={() => resizeComplete()}
                                        >Update Profile Picture</Button>
                                    </Modal.Footer>
                                </Modal>
                                {/* {
                                    showCroper ?
                                        <Cropper
                                            image={imageForCrop}
                                            crop={crop}
                                            zoom={zoom}
                                            aspect={4 / 3}
                                            onCropChange={setCrop}
                                            onCropComplete={onCropComplete}
                                            onZoomChange={setZoom}
                                        /> : null
                                } */}
                            </Tab.Content>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Tab.Container>
                {/* {
                    <Modal show={show} onHide={handleClose} size="sg" style={{ marginTop: 100 }}>
                        <Modal.Header className="d-flex justify-content-between">
                            <h5 className="modal-title" id="post-modalLabel">Create Post</h5>
                            <button type="button" className="btn btn-secondary lh-1" onClick={handleClose} ><span className="material-symbols-outlined">close</span></button>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="d-flex align-items-center">
                                <div className="user-img">
                                    <img loading="lazy" src={user9} alt="userimg" className="avatar-60 rounded-circle img-fluid" />
                                </div>
                                <form className="post-text ms-3 w-100" action="">
                                    <input type="text" className="form-control rounded" placeholder="Write something here..." style={{ border: "none" }} />
                                </form>
                            </div>
                            <Button variant="primary" className="d-block w-100 mt-3">Create Post</Button>
                        </Modal.Body>
                    </Modal>
                } */}


            </Container>


        </>
    )

}

export default UserProfileEdit;